export const images = {
  beetroot_juice: "/images/juice/beetroot_juice.png",
  protein_power_juice: "/images/juice/power_juice.png",
  apple_banana_power_shake: "/images/juice/apple_banana_power_shake.png",
  protin_faste_juice: "/images/juice/protin_faste_juice.png",
  belly_fat_reduce: "/images/juice/belly_fat_reduce.png",
  anti_ageing: "/images/juice/anti_ageing.png",
  detox_juice: "/images/juice/detox_juice.png",
  alkaline_water: "/images/juice/alkaline_water.png",

  fruit: "/images/fruits/fruit_basket_daily_essentials.png",
  market: "/images/fruits/fruit_basket_tropical_mix.png",
  large_basket: "/images/fruits/fruit_basket_premium_seasonal.png",
};

export const fruitSelectionOptions = [
  "Banana",
  "Apple",
  "Orange",
  "Guava",
  "Papaya",
  "Pomegranate",
  "Watermelon",
  "Pineapple",
  // "Grapes",
];

export const fruitSelectionLimits = {
  "small-fruit-basket": 4,
  "medium-fruit-basket": 5,
  "large-fruit-basket": 7,
};

export const products = [
  {
    id: "beetroot_glow_juice",
    type: "protein_shake",
    name: "Beetroot Glow Juice",
    slug: "beetroot-glow-juice",
    description:
      "A vibrant, beetroot-rich fresh juice blended with ginger, lemon juice and a spoon of honey. Naturally earthy, tangy and lightly sweet, served chilled.",
    ingredients: [
      "Beetroot",
      "Fresh ginger",
      "Lemon juice",
      "Honey (1 teaspoon)",
      "Water, as needed",
    ],
    servingSize: "250 ml",
    protein: "~2–4g",
    calories: "~105 kcal",
    carbs: "~23g",
    fat: "~0.5g",
    price: 119,
    image: images.beetroot_juice,
    available: true,
    category: ["Fresh Juice", "Beetroot", "Natural Ingredients"],
  },

  {
    id: "protein_power_juice",
    type: "protein_shake",
    name: "Protein Power Juice",
    slug: "protein-power-juice",
    description:
      "A thick, creamy energy smoothie made with curd (dahi), roasted chana, peanuts, apple, banana, almonds, cashews, raisins, dates, oats, fennel seeds and a touch of jaggery. A satisfying blend of fruit, nuts and traditional ingredients.",
    ingredients: [
      "Curd (Dahi)",
      "Roasted chana",
      "Peanuts",
      "Apple",
      "Banana",
      "Raisins (Kishmish)",
      "Cashews (Kaju)",
      "Almonds (Badam)",
      "Dates (Khajoor)",
      "Fennel seeds (Saunf)",
      "Jaggery (Gud)",
      "Oats (a little)",
      "Water or ice, as needed",
    ],
    servingSize: "300 ml",
    protein: "~12–16g",
    calories: "~350–450 kcal",
    carbs: "~45–60g",
    fat: "~12–18g",
    price: 149,
    image: images.protein_power_juice,
    available: true,
    category: [
      "High Protein",
      "Protein Shake",
      "Fruit & Nut",
      "Natural Energy",
    ],
  },

  {
    id: "banana-apple-anjeer-power",
    type: "protein_shake",
    name: "Banana Apple Anjeer Power",
    slug: "banana-apple-anjeer-power",
    description:
      "A creamy banana and fig protein shake blended with milk, almonds and mixed nuts. Naturally sweet, rich in flavor and perfect for a satisfying energy boost.",
    ingredients: [
      "Banana",
      "Apple",
      "Anjeer (Dried Figs)",
      "Almonds (Badam)",
      "Milk",
      "Mixed Nuts (Cashews, Almonds and other nuts)",
    ],
    servingSize: "300 ml",
    protein: "~10–12g",
    calories: "~280–350 kcal",
    carbs: "~38–48g",
    fat: "~9–13g",
    price: 99,
    image: images.apple_banana_power_shake,
    available: true,
    category: ["Fruit Based", "Nut Based", "Protein Shake", "Natural Energy"],
  },

  {
    id: "fasting-protein-drink",
    type: "protein_shake",
    name: "Fasting Protein Drink",
    slug: "fasting-protein-drink",
    description:
      "A creamy, nourishing milk-based shake blended with almonds, cashews, makhana, dates, mixed dry fruits, cardamom, banana and apple. A satisfying drink for fasting days, with natural sweetness from fruits and dates.",

    ingredients: [
      "Hot Milk",
      "Mixed Dry Fruits (including raisins)",
      "Almonds (Badam)",
      "Cashews (Kaju)",
      "Makhana (Fox Nuts)",
      "Dates (Khajoor)",
      "Cardamom (Elaichi)",
      "Banana",
      "Apple",
    ],
    servingSize: "300 ml",
    protein: "~10–14g",
    calories: "~350–450 kcal",
    carbs: "~45–65g",
    fat: "~10–17g",
    price: 129,
    image: images.protin_faste_juice,
    available: true,
    category: [
      "High Protein",
      "Fasting Special",
      "Milk Based",
      "Dry Fruits",
      "Fruit Based",
    ],
  },

  {
    id: "detox-juice",
    type: "protein_shake",
    name: "Detox Juice",
    slug: "detox-juice",
    description:
      "A refreshing, tangy vegetable juice made with fresh cucumber, carrot, lemon, mint leaves and a pinch of black salt. A light, refreshing blend with a crisp taste, perfect for your daily fresh-juice routine.",
    ingredients: [
      "Cucumber (Kheera)",
      "Carrot (Gajar)",
      "Lemon (Nimbu)",
      "Fresh Mint Leaves (Pudina)",
      "Black Salt (Kala Namak)",
      "Water, as needed",
    ],
    servingSize: "250 ml",
    protein: "~1.5–3.5g",
    calories: "~45–75 kcal",
    carbs: "~10–16g",
    fat: "~0–0.5g",
    price: 99,
    image: images.belly_fat_reduce,
    available: true,
    category: ["Fresh Juice", "Vegetable Based", "Low Calorie", "Mint & Lemon"],
  },

  {
    id: "anti_aging",
    type: "protein_shake",
    name: "Anti Aging Juice",
    slug: "anti_aging",
    description:
      "A tangy, refreshing amla juice prepared with fresh Indian gooseberry, curry leaves, ginger, a little jaggery and black pepper. A distinctive blend of traditional ingredients with a naturally tart, mildly spicy and lightly sweet taste.",
    ingredients: [
      "Amla (Indian Gooseberry) - fruit",
      "Fresh Curry Leaves (Kadi Patta) - 10 leaves",
      "Fresh Ginger - 1 small piece",
      "Jaggery (Gud) - a little",
      "Black Pepper (Kali Mirch) - 5 peppercorns",
      "Water, as needed",
    ],
    servingSize: "250 ml",
    protein: "~1.5–2.5g",
    calories: "~35–65 kcal",
    carbs: "~8–15g",
    fat: "~0–0.5g",
    price: 99,
    image: images.anti_ageing,
    available: true,
    category: [
      "Fresh Juice",
      "Amla",
      "Herbal Blend",
      "Traditional Ingredients",
    ],
  },

  {
    id: "alkaline-water",
    type: "protein_shake",
    name: "FreshLoop Alkaline Water",
    slug: "alkaline-water",
    description:
      "Refreshing infused water prepared with cucumber, mint leaves, beetroot, lemon, coriander leaves, carrot, amla, fresh ginger and chia seeds. Soaked for 12 hours to infuse the water with fresh, earthy, citrus and herbal flavours. Serve chilled.",
    ingredients: [
      "Cucumber (Kheera)",
      "Fresh Mint Leaves (Pudina)",
      "Beetroot",
      "Lemon (Nimbu)",
      "Fresh Coriander Leaves (Dhaniya)",
      "Carrot (Gajar)",
      "Amla (Indian Gooseberry)",
      "Fresh Ginger (Adrak) - a small piece",
      "Chia Seeds",
      "Drinking Water",
    ],
    servingSize: "1000 ml",
    protein: "~1.5–2.5g",
    calories: "~10–35 kcal",
    carbs: "~2–8g",
    fat: "~0–1g",
    price: 89,
    image: images.alkaline_water,
    available: true,
    category: [
      "Infused Water",
      "Fruit & Vegetable Infusion",
      "Mint & Lemon",
      "No Added Sugar",
    ],
  },
  {
    id: "small-fruit-basket",
    type: "fruit_basket",
    name: "Small Fresh Basket",
    slug: "small-fruit-basket",
    description: "A compact seasonal mix for one person.",
    ingredients: ["Banana", "Apple", "Orange", "Guava"],
    weight: "Approx. 2 kg",
    price: 299,
    image: images.fruit,
    available: true,
    category: ["Basket"],
  },
  {
    id: "medium-fruit-basket",
    type: "fruit_basket",
    name: "Medium Fresh Basket",
    slug: "medium-fruit-basket",
    description: "A balanced seasonal mix for couples.",
    ingredients: ["Banana", "Apple", "Orange", "Papaya", "Pomegranate"],
    weight: "Approx. 4 kg",
    price: 549,
    image: images.market,
    available: true,
    category: ["Basket"],
  },
  {
    id: "large-fruit-basket",
    type: "fruit_basket",
    name: "Large Family Basket",
    slug: "large-fruit-basket",
    description: "A generous seasonal fruit selection for families.",
    ingredients: [
      "Banana",
      "Apple",
      "Orange",
      "Papaya",
      "Pomegranate",
      "Watermelon",
    ],
    weight: "Approx. 6 kg",
    price: 799,
    image: images.large_basket,
    available: true,
    category: ["Basket"],
  },
];

export const shakeProducts = products.filter((p) => p.type === "protein_shake");
export const fruitBaskets = products.filter((p) => p.type === "fruit_basket");
export const getProduct = (id) => products.find((p) => p.id === id);
export const timeSlots = [
  // "6:30 AM – 7:00 AM",
  "7:00 AM – 7:30 AM",
  "7:30 AM – 8:00 AM",
  "8:00 AM – 8:30 AM",
  "8:30 AM – 9:00 AM",
  "9:00 AM – 9:30 AM",
  "10:00 AM – 10:30 AM",
  "11:00 AM – 11:30 AM",
];
export const weekdays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const serviceAreas = [
  { pincode: "411045", area: "Baner" },
  { pincode: "411057", area: "Hinjewadi" },
  { pincode: "411016", area: "Model Colony" },
  { pincode: "411038", area: "kothrud" },
  { pincode: "411016", area: "SB Road" },
  // { pincode: "411027", area: "Aundh" },
  // { pincode: "411033", area: "Wakad" },
];

export const initialAddresses = [
  {
    id: "home",
    type: "Home",
    name: "Rahul Sharma",
    mobile: "98765 43210",
    line: "B-304, Green Valley, Baner Road",
    area: "Baner",
    city: "Pune",
    pincode: "411045",
    default: true,
  },
  {
    id: "work",
    type: "Work",
    name: "Rahul Sharma",
    mobile: "98765 43210",
    line: "Blue Ridge SEZ, Phase 1",
    area: "Hinjewadi",
    city: "Pune",
    pincode: "411057",
  },
];

export const sampleDeliveries = [
  {
    id: "del-101",
    productId: "banana-peanut-power",
    date: "Tomorrow",
    fullDate: "30 September 2026",
    timeSlot: "7:30 AM – 8:00 AM",
    addressId: "home",
    quantity: 1,
    amount: 99,
    status: "Scheduled",
    recurring: true,
    days: ["Monday", "Wednesday", "Friday"],
  },
  {
    id: "del-102",
    productId: "medium-fruit-basket",
    date: "Saturday",
    fullDate: "3 October 2026",
    timeSlot: "8:00 AM – 8:30 AM",
    addressId: "home",
    quantity: 1,
    amount: 499,
    status: "Preparing",
    recurring: true,
    days: ["Tuesday", "Saturday"],
  },
  {
    id: "del-099",
    productId: "banana-anjeer-power",
    date: "24 September",
    fullDate: "24 September 2026",
    timeSlot: "7:00 AM – 7:30 AM",
    addressId: "home",
    quantity: 1,
    amount: 89,
    status: "Delivered",
    recurring: false,
    days: [],
  },
];

export function makeNotifications(deliveries = []) {
  return deliveries.slice(0, 3).map((delivery, index) => {
    const product = getProduct(delivery.productId);
    if (index === 0) {
      return {
        id: `delivery-${delivery.id}`,
        icon: "fa-calendar-check",
        title:
          delivery.status === "Delivered" ? "Delivered" : "Delivery coming up",
        body: `${product?.name || "Your delivery"} is scheduled for ${delivery.date || "your selected date"}${delivery.timeSlot ? ` at ${delivery.timeSlot.split(" – ")[0]}` : ""}.`,
        time: delivery.date || "Upcoming",
      };
    }
    if (delivery.status === "Delivered") {
      return {
        id: `delivered-${delivery.id}`,
        icon: "fa-circle-check",
        title: "Delivered",
        body: `${product?.name || "Your order"} was delivered successfully.`,
        time: delivery.date || "Completed",
      };
    }
    return {
      id: `preparing-${delivery.id}`,
      icon: "fa-basket-shopping",
      title: delivery.status || "Preparing",
      body: `${product?.name || "Your order"} is being prepared for ${delivery.date || "your next delivery"}.`,
      time: delivery.date || "Upcoming",
    };
  });
}

// const images = {
//   banana:
//     "https://images.unsplash.com/photo-1685967836529-b0e8d6938227?auto=format&fit=crop&w=1200&q=85",
//   chocolate:
//     "https://images.unsplash.com/photo-1542444592-e6880e286bb9?auto=format&fit=crop&w=1200&q=85",
//   mango:
//     "https://images.unsplash.com/photo-1712056407284-c1eda76e7bcd?auto=format&fit=crop&w=1200&q=85",
//   fruit:
//     "https://images.unsplash.com/photo-1553195027-a67fd5ed99d5?auto=format&fit=crop&w=1400&q=8"
// }
